const agentAddOptions = [
  {
    label: 'TAK',
    value: 'TAK',
    state: 'agentAdd',
  },
  {
    label: 'NIE',
    value: 'NIE',
    state: 'agentAdd',
  },
];

const agentDict = {
  agentName: {
    label: 'Imię i nazwisko:',
    editable: true,
  },
  agentAddress: {
    label: 'Adres zamieszkania:',
    editable: true,
    type: 'textarea',
  },
  agentPostOffice: {
    label: 'Urząd Pocztowy:',
    editable: true,
  },
  agentPostalCode: {
    label: 'Kod pocztowy:',
    editable: true,
  },
  agentPhoneNumber: {
    label: 'Tel. kontaktowy:',
    editable: true,
  },
  agentMotionAddress: {
    label: 'Adres do korespondencji:',
    editable: true,
    type: 'textarea',
  },
};

const agentInfoDict = {
  agentAdd: {
    label: 'Pełnomocnik:',
    editable: true,
    type: 'Select',
    options: agentAddOptions,
  },
};

const agentConfig = { agentDict: { ...agentDict }, agentInfoDict: { ...agentInfoDict } };
export default agentConfig;



// WEBPACK FOOTER //
// src/routes/eservices/agent.js